<template>
    <div class="mt-4">
        <b-row>
            <b-col lg="12" md="12" sm="12">
                <div class="table-responsive">
                    <table class="table table-striped detail-table">
                        <tbody>
                        <template v-if="isEmpty(other_info)">
                            <tr v-for="(row, index) in other_info">
                                <td class="detail-table-label">{{index | rowTitleFormat }}</td>
                                <td>{{row | arrayValuesFormatter }}</td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  import TableDataExcluder from '@/mixins/table-data-excluder';

  export default {
    props: {
      patient: {
        type: Object
      }
    },
    mixins: [TableDataExcluder],
    computed: {
      other_info() {
        return this.excluder(this.patient.other_info || {}, this.excludedFields);
      }
    },

    data() {
      return {
        excludedFields: ['id']
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Patient/Detail/InformationTab/OtherInfoTab.vue